var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoingecko({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 16.203C32.0398 25.1032 24.9085 32.3503 16.0727 32.3906C7.23579 32.4309 0.0401701 25.2485 0.000167473 16.3482C-0.0398351 7.44801 7.09154 0.200848 15.9285 0.160559C24.7642 0.121491 31.9598 7.30272 31.9998 16.203Z",
    fill: "#FFE866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1145 10.509C22.9532 10.1708 21.7507 9.68979 20.5313 9.2051C20.4609 8.89743 20.1906 8.51408 19.6427 8.04404C18.8463 7.34813 17.3504 7.36645 16.0582 7.67411C14.6315 7.33593 13.2217 7.21506 11.8689 7.54225C0.806333 10.6128 7.07826 18.1004 3.01617 25.6296C3.59439 26.8639 9.97172 32.7942 18.8378 32.1357C18.8378 32.1357 15.7552 24.6749 22.712 21.0928C28.3548 18.1884 32.4314 12.7945 24.1133 10.5078L24.1145 10.509Z",
    fill: "#4BCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8243 12.3042C16.8243 14.0256 15.4388 15.4199 13.7308 15.4199C12.0228 15.4199 10.6373 14.0256 10.6373 12.3042C10.6373 10.5827 12.0228 9.1897 13.7308 9.1897C15.4388 9.1897 16.8243 10.5839 16.8243 12.3042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9862 16.7882C25.4806 18.567 22.6283 19.9161 18.5856 19.9161C16.6933 19.9161 16.3091 17.8906 15.0581 18.8832C14.412 19.396 12.1355 20.5424 10.3281 20.4557C8.50493 20.3678 5.59444 19.3007 4.7762 15.4171C4.45255 19.3007 4.28769 22.1625 2.83911 25.4418C6.39505 30.6678 12.5951 33.2679 18.8377 32.1371C18.1674 27.4208 22.2598 22.8022 24.5654 20.4386C25.4382 19.5437 27.111 18.0823 27.9862 16.7882Z",
    fill: "#4BCC00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.0348,
    cy: 12.2829,
    rx: 1.81532,
    ry: 2.54145,
    fill: "#0D1217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7609 7.6682C16.7513 8.06406 20.3681 9.26871 21.933 9.74159C20.3352 7.09051 17.914 7.24349 15.7609 7.6682Z",
    fill: "#35AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0347 12.2826L12.8563 10.8303V13.7348L15.0347 12.2826Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32.3396,
    fill: "white",
    transform: "translate(0 0.1604)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoingecko);
export default __webpack_public_path__ + "static/media/coingecko.e8845111c0ca5d9989725ea8f6b35b3e.svg";
export { ForwardRef as ReactComponent };